import { render } from "./TechnologyPage.vue?vue&type=template&id=584a3785&scoped=true"
import script from "./TechnologyPage.vue?vue&type=script&lang=js"
export * from "./TechnologyPage.vue?vue&type=script&lang=js"

import "./TechnologyPage.vue?vue&type=style&index=0&id=584a3785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584a3785"]])

export default __exports__